export default {
    spaces: [
        {value: { order: 'name', direction: 'asc'}, title: 'By name (A-Z)'},
        {value: { order: 'name', direction: 'desc'}, title: 'By name (Z-A)'},
        {value: { order: 'id', direction: 'desc' }, title: 'ID (Z-A)'},
    ],
    projects: [
        {value: { order: 'name', direction: 'asc'}, title: 'By name (A-Z)'},
        {value: { order: 'name', direction: 'desc'}, title: 'By name (Z-A)'},
        {value: { order: 'id', direction: 'desc' }, title: 'ID (Z-A)'},
    ],
    tasks: [
        {value: { order: 'title', direction: 'asc'}, title: 'By name (A-Z)'},
        {value: { order: 'title', direction: 'desc'}, title: 'By name (Z-A)'},
    ],
}
